export { createSyntheticModuleFallback } from "./create-synthetic-module-fallback";
